import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import firebase from 'firebase';

@Injectable({
  providedIn: 'root',
})
export class ScholarshipService {
  constructor(private DATABASE: AngularFirestore) {}

  collection = 'scholarship';

  getCollection() {
    return this.DATABASE.collection(this.collection);
  }

  uploadAttachments(file, folderName) {
    return firebase
      .storage()
      .ref()
      .child(`scholarship2022/${folderName}/${file.name}`)
      .put(file);
  }

  createScholarshipSubmission(form) {
    return this.DATABASE.collection(this.collection)
      .doc('2022 Scholarship')
      .collection('submissions')
      .doc(form.id)
      .set(form);
  }
}
